<template>
  <div class="relative mt-10 bg-green-700">
    <div class="mx-auto max-w-3xl px-8 py-10 md:py-10 lg:max-w-6xl lg:py-20">
      <div class="flex-wrap items-center lg:flex lg:justify-between">
        <div>
          <h3
            class="relative max-w-lg text-2xl font-semibold leading-tight tracking-tight text-white md:text-4xl lg:max-w-xl lg:text-4xl lg:leading-tight"
          >
            Kick start your net-zero emission goal with Zuno Carbon.
          </h3>

          <!-- <div class="grid grid-cols-2 gap-0 py-8 lg:mt-5 lg:flex lg:grid-cols-4 md:grid-cols-2 lg:gap-4">
            <div class="flex gap-2 mb-3 md:mb-3 lg:mb-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="24"
                  height="24"
                  rx="6.54545"
                  fill="#DCF2ED"
                />
                <g clip-path="url(#clip0_18_1478)">
                  <path
                    d="M10.3635 14.2738L8.089 11.9993L7.31445 12.7684L10.3635 15.8175L16.909 9.27202L16.1399 8.50293L10.3635 14.2738Z"
                    fill="#037957"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_18_1478">
                    <rect
                      width="13.0909"
                      height="13.0909"
                      fill="white"
                      transform="translate(5.45456 5.4541)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="text-gray-200 text-[18px] md:text-base">No obligation</span>
            </div>
            <div class="flex gap-2 mb-3 md:mb-3 lg:mb-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="24"
                  height="24"
                  rx="6.54545"
                  fill="#DCF2ED"
                />
                <g clip-path="url(#clip0_18_1478)">
                  <path
                    d="M10.3635 14.2738L8.089 11.9993L7.31445 12.7684L10.3635 15.8175L16.909 9.27202L16.1399 8.50293L10.3635 14.2738Z"
                    fill="#037957"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_18_1478">
                    <rect
                      width="13.0909"
                      height="13.0909"
                      fill="white"
                      transform="translate(5.45456 5.4541)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="text-gray-200 text-[18px] md:text-base">Free onboarding</span>
            </div>
            <div class="flex gap-2 mb-3 md:mb-3 lg:mb-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="24"
                  height="24"
                  rx="6.54545"
                  fill="#DCF2ED"
                />
                <g clip-path="url(#clip0_18_1478)">
                  <path
                    d="M10.3635 14.2738L8.089 11.9993L7.31445 12.7684L10.3635 15.8175L16.909 9.27202L16.1399 8.50293L10.3635 14.2738Z"
                    fill="#037957"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_18_1478">
                    <rect
                      width="13.0909"
                      height="13.0909"
                      fill="white"
                      transform="translate(5.45456 5.4541)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="text-gray-200 text-[18px] md:text-base">14 day free trial</span>
            </div>
            <div class="flex gap-2 mb-3 md:mb-3 lg:mb-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="24"
                  height="24"
                  rx="6.54545"
                  fill="#DCF2ED"
                />
                <g clip-path="url(#clip0_18_1478)">
                  <path
                    d="M10.3635 14.2738L8.089 11.9993L7.31445 12.7684L10.3635 15.8175L16.909 9.27202L16.1399 8.50293L10.3635 14.2738Z"
                    fill="#037957"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_18_1478">
                    <rect
                      width="13.0909"
                      height="13.0909"
                      fill="white"
                      transform="translate(5.45456 5.4541)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <span class="text-gray-200 text-[18px] md:text-base">Full features</span>
            </div>
          </div> -->
        </div>
        <div>
          <NuxtLink
            to="/contact-us"
            class="block w-full select-none rounded-md border border-gray-200 bg-white px-5 py-3 text-center text-sm font-normal text-gray-900 hover:bg-gray-100 active:bg-white lg:w-auto lg:px-10 lg:py-4 lg:text-sm"
          >
            <span>Request a Demo</span>
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="hidden lg:absolute lg:bottom-0 lg:right-0 lg:block">
      <NuxtImg
        src="/website/scribble-04.svg"
        class="w-full"
        alt="Scribble"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CtaSection',
}
</script>
